/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateFacilityServiceAreaUploadUrlResponse } from './CreateFacilityServiceAreaUploadUrlResponse';
import {
    CreateFacilityServiceAreaUploadUrlResponseFromJSON,
    CreateFacilityServiceAreaUploadUrlResponseFromJSONTyped,
    CreateFacilityServiceAreaUploadUrlResponseToJSON,
} from './CreateFacilityServiceAreaUploadUrlResponse';

/**
 * 
 * @export
 * @interface CreateFacilityServiceAreaUploadUrl200Response
 */
export interface CreateFacilityServiceAreaUploadUrl200Response {
    /**
     * 
     * @type {CreateFacilityServiceAreaUploadUrlResponse}
     * @memberof CreateFacilityServiceAreaUploadUrl200Response
     */
    data?: CreateFacilityServiceAreaUploadUrlResponse;
}

/**
 * Check if a given object implements the CreateFacilityServiceAreaUploadUrl200Response interface.
 */
export function instanceOfCreateFacilityServiceAreaUploadUrl200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateFacilityServiceAreaUploadUrl200ResponseFromJSON(json: any): CreateFacilityServiceAreaUploadUrl200Response {
    return CreateFacilityServiceAreaUploadUrl200ResponseFromJSONTyped(json, false);
}

export function CreateFacilityServiceAreaUploadUrl200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceAreaUploadUrl200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CreateFacilityServiceAreaUploadUrlResponseFromJSON(json['data']),
    };
}

export function CreateFacilityServiceAreaUploadUrl200ResponseToJSON(value?: CreateFacilityServiceAreaUploadUrl200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateFacilityServiceAreaUploadUrlResponseToJSON(value.data),
    };
}

